import React, { useState } from 'react';
import { apiService } from '../../services/apiService';
import InlineSpinner from '../common/InlineSpinner';
import styles from './InviteCompanyModal.module.css';

interface InviteCompanyFormProps {
  onSuccess?: () => void;
  onCancel?: () => void;
}

const InviteCompanyForm: React.FC<InviteCompanyFormProps> = ({ onSuccess, onCancel }) => {
  const [email, setEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await apiService.createPortfolioInvite(email, companyName);
      if (response.success) {
        setEmail('');
        setCompanyName('');
        if (onSuccess) {
          onSuccess();
        }
      }
    } catch (err: any) {
      setError(err.message || 'Failed to send invitation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.modal}>
      <div className={styles.header}>
        <h2 className={styles.title}>Invite Portfolio Company</h2>
        {onCancel && (
          <button onClick={onCancel} className={styles.closeButton}>×</button>
        )}
      </div>

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
          <label htmlFor="companyName" className={styles.label}>
            COMPANY NAME
          </label>
          <input
            id="companyName"
            type="text"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            required
            disabled={loading}
            placeholder="e.g., Acme Corp"
            className={styles.input}
          />
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="email" className={styles.label}>
            FOUNDER EMAIL
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
            placeholder="founder@company.com"
            className={styles.input}
          />
        </div>

        <div className={styles.infoBox}>
          <div className={styles.infoTitle}>Invitation includes:</div>
          <div className={styles.infoList}>
            <div className={styles.infoItem}>✓ Onboarding link to set up their account</div>
            <div className={styles.infoItem}>✓ Instructions to connect integrations</div>
            <div className={styles.infoItem}>✓ Update schedule and templates</div>
          </div>
        </div>

        {error && (
          <div className={styles.error}>{error}</div>
        )}

        <div className={styles.actions}>
          {onCancel && (
            <button type="button" onClick={onCancel} className={styles.cancelButton} disabled={loading}>
              Cancel
            </button>
          )}
          <button type="submit" className={styles.submitButton} disabled={loading}>
            {loading ? (
              <>
                <InlineSpinner />
                <span>Sending...</span>
              </>
            ) : (
              'Send Invite'
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default InviteCompanyForm;

